module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/3811248d93cb8b72f0c99f11e8349207.png";